export default {
    PROGRESSIVE: 'progressive',
    BAR: 'bar',
};
